import React from "react";
import ProgressBar from "../controls/ProgressBar";
const readable = (input) => {
    if (input === undefined) {
        return "Done";
    }
    return input
        .split(/[_-]/)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
};
export const LoadingScreen = (props) => {
    const { extensions } = props;
    const [currentlyLoading, setCurrentlyLoading] = React.useState("");
    const [loaded, setLoaded] = React.useState(0);
    const totalExtensions = React.useMemo(() => extensions.numOnce, [extensions]);
    React.useEffect(() => {
        extensions.onLoadingExtension((name, idx) => {
            setCurrentlyLoading(name);
            setLoaded(idx);
        });
    }, [extensions]);
    return (React.createElement("div", { id: "loading-screen" },
        React.createElement(ProgressBar, { labelLeft: "Loading Extensions", labelRight: readable(currentlyLoading), max: totalExtensions, now: loaded })));
};
export default LoadingScreen;
